module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.customerMaterialInfo), function(customerMaterial, index) {
    return _c('div', [_c('div', {
      staticClass: "main3 flex-col"
    }, [_c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "mod3 flex-row"
    }, [_c('span', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(customerMaterial.receiveWareName))]), _vm._v(" "), (customerMaterial.orderNo !== undefined) ? _c('span', {
      staticClass: "txt",
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_vm._v(_vm._s(customerMaterial.orderNo))]) : _c('span', {
      staticClass: "txt",
      staticStyle: {
        "white-space": "nowrap"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "txt middle-fixed-width"
    }, [_vm._v(_vm._s(customerMaterial.receiveDT))]), _vm._v(" "), _c('span', {
      staticClass: "txt samll-fixed-width"
    }, [_vm._v(_vm._s(customerMaterial.statusName))]), _vm._v(" "), _c('span', {
      staticClass: "txt samll-fixed-width"
    }, [_vm._v(_vm._s(customerMaterial.goodsQuantity))])])])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main2 flex-col"
  }, [_c('div', {
    staticClass: "section1 flex-row"
  }, [_c('span', {
    staticClass: "word"
  }, [_vm._v("实物名称")]), _vm._v(" "), _c('span', {
    staticClass: "word"
  }, [_vm._v("订单号")]), _vm._v(" "), _c('span', {
    staticClass: "word"
  }, [_vm._v("到达时间")]), _vm._v(" "), _c('span', {
    staticClass: "word"
  }, [_vm._v("在库状态")]), _vm._v(" "), _c('span', {
    staticClass: "word"
  }, [_vm._v("剩余量")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6dcf1ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/Material/MaterialInquire.vue
// module id = 1734
// module chunks = 8